import { LocalDate } from '@js-joda/core';

import { BindingCreator } from '@dreryk/react-common';
import { DatePicker } from '@dreryk/react-components';

import { invoiceSharedComponentsTranslationKeys } from '../translations';

const PAYMENT_DATE_FIELD_NAME = 'paymentDate';

export type PaymentDateFormBeanPart = {
   [PAYMENT_DATE_FIELD_NAME]: LocalDate;
};

type PaymentDateFieldProps = {
   readonly disabled: boolean;
   readonly register: BindingCreator<PaymentDateFormBeanPart, typeof PAYMENT_DATE_FIELD_NAME>;
};

export const PaymentDateField = (props: PaymentDateFieldProps): JSX.Element => {
   return (
      <DatePicker
         controller={props.register(PAYMENT_DATE_FIELD_NAME, {
            required: true,
         })}
         testId={PAYMENT_DATE_FIELD_NAME}
         label={invoiceSharedComponentsTranslationKeys.paymentDate}
         disabled={props.disabled}
      />
   );
};
